import { render, staticRenderFns } from "./PurchasePrepaid.vue?vue&type=template&id=47db730a"
import script from "./PurchasePrepaid.vue?vue&type=script&lang=js"
export * from "./PurchasePrepaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports